import cn from 'classnames';

const useClassname = ({ className, classNames = [] }: any) =>
	className || cn(...classNames);

export default useClassname;
